var map = {
	"./additionalInfoIcon.svg": 612,
	"./arrowLeftIcon.svg": 613,
	"./arrowMediumTop.svg": 614,
	"./arrowRightIcon.svg": 615,
	"./arrowRightIconSharp.svg": 616,
	"./arrowRightSmallIcon.svg": 617,
	"./arrowScalableIcon.svg": 618,
	"./arrowSelect2.svg": 619,
	"./arrowSelectIcon.svg": 620,
	"./benefit1.svg": 621,
	"./benefit2.svg": 622,
	"./benefit3.svg": 623,
	"./cardsIcon.svg": 624,
	"./checkCirсleIcon.svg": 625,
	"./circleInfoIcon.svg": 626,
	"./copyIcon copy.svg": 627,
	"./copyIcon.svg": 628,
	"./crossIcon.svg": 629,
	"./crossIcon2.svg": 630,
	"./crossIcon3.svg": 631,
	"./crossIconSmall.svg": 632,
	"./crossSmallIcon.svg": 633,
	"./defaultCategoryIcon.svg": 634,
	"./depNumberIcon.svg": 635,
	"./elfCentralIcon.svg": 636,
	"./equalitySign.svg": 637,
	"./errorIcon.svg": 638,
	"./eyeClosedIcon.svg": 639,
	"./eyeOpenIcon.svg": 640,
	"./favoritesIcon.svg": 641,
	"./favoritesLabelIcon.svg": 642,
	"./filterDivider.svg": 643,
	"./filterIcon.svg": 644,
	"./frequencyIcon.svg": 645,
	"./fsAmountIcon.svg": 646,
	"./fullScreenIcon.svg": 647,
	"./gameIcon.svg": 648,
	"./goldGiftIcon.svg": 649,
	"./hamburgerIcon.svg": 650,
	"./infoIcon.svg": 651,
	"./infoSymbol.svg": 652,
	"./levelBackground.svg": 653,
	"./levelBackgroundNew.svg": 654,
	"./linkIcon.svg": 655,
	"./lockIcon.svg": 656,
	"./lockSharpIcon.svg": 657,
	"./maxBonusAmountIcon.svg": 658,
	"./maxWinFsIcon.svg": 659,
	"./menu/fortuneIcon.svg": 377,
	"./menu/fortuneIconL.svg": 378,
	"./menu/helpdeskIcon.svg": 379,
	"./menu/helpdeskIconL.svg": 380,
	"./menu/homeIcon.svg": 381,
	"./menu/homeIconLarge.svg": 382,
	"./menu/jackpotIcon.svg": 383,
	"./menu/logo.svg": 384,
	"./menu/logoSmall.svg": 385,
	"./menu/loyaltyIcon.svg": 386,
	"./menu/mobileAppIcon.svg": 387,
	"./menu/profileIcon.svg": 388,
	"./menu/questIcon.svg": 389,
	"./menu/questsIcon.svg": 390,
	"./menu/rewardLineupIcon.svg": 391,
	"./menu/searchIcon.svg": 392,
	"./menu/searchIconLarge.svg": 393,
	"./menu/signOutIcon.svg": 394,
	"./menu/star.svg": 395,
	"./menu/tournamentIcon.svg": 396,
	"./menu/tournamentLargeIcon.svg": 397,
	"./menu/vipIcon.svg": 398,
	"./menu/wheelIcon.svg": 399,
	"./menu/wheelIconL.svg": 400,
	"./menu/wheelIconMobile.svg": 401,
	"./menuIcon.svg": 660,
	"./minDepIcon.svg": 661,
	"./noTournamentIcon.svg": 662,
	"./numbers/number-1.svg": 402,
	"./numbers/number-2.svg": 403,
	"./numbers/number-3.svg": 404,
	"./numbers/number-4.svg": 405,
	"./numbers/number-5.svg": 406,
	"./numbers/number-6.svg": 407,
	"./numbers/number-7.svg": 408,
	"./numbers/number-8.svg": 409,
	"./numbers/number-9.svg": 410,
	"./numbers/number-shine-1.svg": 411,
	"./numbers/number-shine-2.svg": 412,
	"./numbers/number-shine-3.svg": 413,
	"./numbers/number-shine-4.svg": 414,
	"./numbers/number-shine-5.svg": 415,
	"./numbers/number-shine-6.svg": 416,
	"./numbers/number-shine-7.svg": 417,
	"./numbers/number-shine-8.svg": 418,
	"./numbers/number-shine-9.svg": 419,
	"./playIcon.svg": 663,
	"./polygon.svg": 664,
	"./preloaderDotsAnimation.svg": 665,
	"./preloaderSpinnerAnimation.svg": 666,
	"./presentIcon.svg": 667,
	"./promoIcon.svg": 668,
	"./recentIcon.svg": 669,
	"./search2Icon.svg": 670,
	"./search3Icon.svg": 671,
	"./sharpTickIcon copy.svg": 672,
	"./sharpTickIcon.svg": 673,
	"./smallInfoSymbol.svg": 674,
	"./smoothArrowIcon.svg": 675,
	"./successIcon.svg": 676,
	"./supportIcon.svg": 677,
	"./tag1Icon.svg": 678,
	"./tag2Icon.svg": 679,
	"./tag3Icon.svg": 680,
	"./tag4Icon.svg": 681,
	"./tickIcon.svg": 682,
	"./unverified.svg": 683,
	"./verified.svg": 684,
	"./wagerIcon.svg": 685,
	"./wagerTimeIcon.svg": 686,
	"./warningIcon.svg": 687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 611;